/**
 * API token generation, shared by the Account API-tokens panel and the
 * Sites "Publish from your AI agent" modal so both create byte-identical
 * token docs.
 *
 * Raw tokens are aero_ + base64url(32 random bytes) and are shown EXACTLY
 * once at creation; Firestore stores only sha256(rawToken) plus display
 * metadata, so a leaked database never leaks usable tokens. The aero_ prefix
 * makes stray tokens recognizable in code reviews and secret scanners.
 */
export const API_TOKEN_PREFIX_LENGTH = 12; // "aero_" + 7 chars, enough to recognize

export async function generateApiToken() {
  const bytes = new Uint8Array(32);
  window.crypto.getRandomValues(bytes);
  const base64url = btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  const token = 'aero_' + base64url;
  const digest = await window.crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(token)
  );
  const hashedToken = Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return { token, hashedToken, prefix: token.slice(0, API_TOKEN_PREFIX_LENGTH) };
}
